import { Spinner } from '@/components/ui/spinner'

export function RouteHydrateFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Spinner />
    </div>
  )
}
